import { get } from '../helpers/api.helper';

export async function GetLastSales(year = undefined, month = undefined) {
    try {
        if (year !== undefined && month !== undefined) {
            return await get(`finalizavenda/user/paginated?year=${year}&month=${month}`);
        }

        return await get('finalizavenda/user');
    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}

export async function GetTopProducts(quantity, year) {
    try {
        return await get(`v2/dashboard/top-products?quantity=${quantity}&year=${year}`);
    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}

export async function GetTotalUsers() {
    try {
        return await get('v2/dashboard/users/count');
    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}

export async function GetTopResalers(year, month) {
    try {
        return await get(`v2/dashboard/top-resalers?month=${month}&year=${year}`);
    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}
